<template>
  <ul role="list" class="flex flex-wrap">
    <ColorPicker
      v-for="field in section.fields"

      :isOverwritting="isOverwritting"

      :key="field.id"
      class="mt-2 mr-2"

      :value="vuelidate[field.id].$model || field.default"
      @input="(val) => setValue(section.id, field.id, val)"
      :id="field.id"
      :placeholder="field.default"
      :deletable="field.deletable"
      :label="field.label"
      :vuelidate="vuelidate"
      :fieldName="field.id"
      :loading="true"

      @remove="removeField(field.id, section)"
    />
    <AddNewField v-if="!isOverwritting && ready && section.newField"
      @save="(field) => addNewField(section.fields, field)"
      class="mt-2 mr-2"
    />
  </ul>
</template>

<script>

import ColorPicker from './ColorPicker.vue'
import AddNewField from './AddNewField.vue'

export default {
  components: {
    ColorPicker,
    AddNewField,
  },
  props: ['section', 'ready', 'vuelidate', 'isOverwritting'],
  methods: {
    addNewField(fields, field) {
      if (fields.find((item) => item.id === field.id)) return this.$error("There is already another field with the same id.")
      fields.push(field)
      this.$emit("refetch-blocks")

      this.$emit("updated")
    },
    setValue(sectionId, fieldId, val) {
      this.vuelidate[fieldId].$model = val
      this.$forceUpdate()

      this.$emit("updated")
    },
    removeField(fieldId, {fields, id}) {
      fields.splice(
        fields.findIndex((item) => item.id === fieldId),
        1
      )
      this.$emit("delete-field", {section: id, id: fieldId})
      this.$emit("remove-field", fieldId)

      this.$emit("updated")
    },
  },
}

</script>
